export default {
      id: "forme_bg_rs-usage",
      viewBox: "0 0 2500 880",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#forme_bg_rs-usage",
      toString: function () {
        return this.url;
      }
    }